import {getSectionIdComparisonRegex} from "../../utils/svg-utils";
import {useAtomValue} from "jotai";
import {selectedMarketplaceEventAtom} from "../../data/atoms";
import {BrokerNerdsBarkerCoreModelsMarketplacesGetSeatingChartResponseWithCategories} from "../../api";

export function useSectionHighlight(section: string) {
  // Lowercase the section so we can match the ID for Seat Geek seating chart
  const seatGeekSectionId = section.replace(/\s+/g, '-').toLowerCase();
  const {svgDetails} = useAtomValue(selectedMarketplaceEventAtom);

  const ticomboSectionId = section.toLowerCase().replaceAll(' ', '-');
  const sectionRegex = getSectionIdComparisonRegex(section);
  const ticCat = (svgDetails as BrokerNerdsBarkerCoreModelsMarketplacesGetSeatingChartResponseWithCategories)?.categories?.find(c => sectionRegex?.test(c.name))?.sectionId;

  // Ticket master seems to do upper case currently for venues looked at.
  const ticketMasterSectionId = section.toUpperCase();

  // Capitalize the first letter of each word so we can match the data attribute value for Tevo seating chart
  const tevoSection = section.split(' ');
  const tevoSectionId = tevoSection.map((word) => (word[0] ?? '').toUpperCase() + word.slice(1)).join(' ');

  const highlightSection = () => {
    document.getElementById('seatingChartSVG')?.classList.add('highlighting');
    const seatGeekSectionHovered = document.getElementById(`${seatGeekSectionId}`);
    const ticketMasterSectionHovered = document.querySelector(`[data-section-id="${ticketMasterSectionId}"]`);
    const tevoSectionHovered = [...document.querySelectorAll(`[data-section-id="${tevoSectionId}"]`)];
    const ticomboSectionHovered = [...document.querySelectorAll(`[data-category="${ticCat}"]`)];
    if (!ticomboSectionHovered.length) {
      const tcSection = document.querySelector(`[data-section="${ticomboSectionId}"]`);
      if (tcSection) ticomboSectionHovered.push(tcSection);
    }

    seatGeekSectionHovered?.classList.add('market-hover');
    ticketMasterSectionHovered?.classList.add('market-hover');
    tevoSectionHovered?.forEach((tevoPath) => {
      tevoPath.classList.add('market-hover');
    });
    ticomboSectionHovered?.forEach((ticomboPath) => {
      ticomboPath.classList.add('market-hover');
    });
  };
  const unhighlightSection = () => {
    document.getElementById('seatingChartSVG')?.classList.remove('highlighting');
    const nodesHovered = [...document.querySelectorAll('.market-hover')];

    nodesHovered?.forEach((node) => {
      node.classList.remove('market-hover');
    });
  };

  return {highlightSection, unhighlightSection};
}
